module.exports = __webpack_public_path__ + "img/00039.62d9f680.webp";